import React from "react";
import { Flex, Text, useToken } from "@chakra-ui/react";

export function Separator(props) {
  const { hasTitle, children, ...rest } = props;

  const [separatorBg] = useToken("colors", ["sidebar_seprator_bg"]);
  

  if (!hasTitle) {
    return (
      <Flex
        h="1px"
        w="100%"
        bg={separatorBg}
        {...rest}
      />
    );
  }

 return (
  <Flex align="center"  w="100%" {...rest}>
    <Text
      px={1}
      fontSize="sm"
      color="#FFFFFF"
      whiteSpace="nowrap"
    >
      {hasTitle}
    </Text>

    <Flex flex={1} h="2px" bg={separatorBg} />
  </Flex>
);
}